import {useContext} from 'react'
import {OrderItemsContext, WaiterContext} from './Context/WaiterContext'
import {getHours} from 'date-fns'

function Heading({page}) {
    const {orderItems} = useContext(OrderItemsContext)
    const {waiter} = useContext(WaiterContext)
    const renderHi = () => {
        const currentHour = getHours(new Date())

        if (currentHour > 23) {
            return 'Hi'
        } else if (currentHour > 5 && currentHour < 12) {
            return 'Good morning'
        } else if (currentHour > 12 && currentHour < 18) {
            return 'Good afternoon'
        } else {
            return 'Good evening'
        }
    }
    if (page === 'time' || page === 'menu') {
        return <>
            <h1>{renderHi()}, {waiter?.name}!</h1>
            <p>
                Create an order
            </p>
        </>
    }

    if (orderItems) {
        return <>
            <h1>Hello, {waiter?.name}!</h1>
        </>
    } else {
        return <h1>{renderHi()}, {waiter?.name}!</h1>
    }
}


export default Heading;
